export default {
  default: 'default',
  canteen: 'canteen',
  pantry: 'pantry',
  social: 'social',
  market: 'market',
  companykitchen: 'companykitchen',
  refive: 'refive',
};
